import {Button, ColouredContainer, FlexColumn, FlexRow} from '@forecast-it/design-system';
import React from 'react';

interface AddCurrencyRateRowProps {
	onConfirm: () => void;
	onCancel: () => void;
	isConfirmDisabled: boolean;
	children: React.ReactNode;
}

export const AddCurrencyRateRow = ({onConfirm, onCancel, isConfirmDisabled, children}: AddCurrencyRateRowProps) => (
	<ColouredContainer backgroundColor={ColouredContainer.BackgroundColor.BLUE_100}>
		<FlexRow justifyContent={'space-between'} alignItems={'center'}>
			<FlexColumn>
				<FlexRow gap="l">{children}</FlexRow>
			</FlexColumn>
			<FlexColumn>
				<FlexRow justifyContent={'flex-end'}>
					<Button icon="tick" emphasis="high" onPress={onConfirm} disabled={isConfirmDisabled} />
					<Button icon="close" emphasis="medium" onPress={onCancel} />
				</FlexRow>
			</FlexColumn>
		</FlexRow>
	</ColouredContainer>
);
